var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "bg-dark", attrs: { toggleable: "md", type: "dark" } },
    [
      _c(
        "div",
        { staticClass: "jh-logo-container float-left" },
        [
          _c(
            "b-navbar-toggle",
            {
              staticClass: "jh-navbar-toggler d-lg-none float-right",
              attrs: {
                right: "",
                href: "javascript:void(0);",
                "data-toggle": "collapse",
                target: "header-tabs",
                "aria-expanded": "false",
                "aria-label": "Toggle navigation"
              }
            },
            [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-brand",
            {
              staticClass: "logo float-left",
              attrs: { "b-link": "", to: "/" }
            },
            [
              _c("span", { staticClass: "logo-img" }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "navbar-title",
                  domProps: { textContent: _vm._s(_vm.$t("global.title")) }
                },
                [_vm._v("smartcc_backend")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "header-tabs" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                _c(
                  "span",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "home" } }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        domProps: {
                          textContent: _vm._s(_vm.$t("global.menu.home"))
                        }
                      },
                      [_vm._v("Home")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: { id: "entity-menu", "active-class": "active" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "th-list" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.main")
                                )
                              }
                            },
                            [_vm._v("Entities")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/dialogue" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.dialogue")
                                )
                              }
                            },
                            [_vm._v("Dialogue")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/person" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.person")
                                )
                              }
                            },
                            [_vm._v("Person")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/utterance" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.utterance")
                                )
                              }
                            },
                            [_vm._v("Utterance")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/sentence" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.sentence")
                                )
                              }
                            },
                            [_vm._v("Sentence")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/word" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.word")
                                )
                              }
                            },
                            [_vm._v("Word")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/dependency-graph" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.dependencyGraph")
                                )
                              }
                            },
                            [_vm._v("DependencyGraph")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/metadata" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.metadata")
                                )
                              }
                            },
                            [_vm._v("Metadata")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/customer" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.customer")
                                )
                              }
                            },
                            [_vm._v("Customer")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/address" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.address")
                                )
                              }
                            },
                            [_vm._v("Address")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/bank-account" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.bankAccount")
                                )
                              }
                            },
                            [_vm._v("BankAccount")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/payment-card" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.paymentCard")
                                )
                              }
                            },
                            [_vm._v("PaymentCard")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/model-version" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.modelVersion")
                                )
                              }
                            },
                            [_vm._v("ModelVersion")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/email" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.email")
                                )
                              }
                            },
                            [_vm._v("Email")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority("ROLE_ADMIN")
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      class: {
                        "router-link-active": _vm.subIsActive("/admin")
                      },
                      attrs: { id: "admin-menu", "active-class": "active" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "user-plus" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.main")
                                )
                              }
                            },
                            [_vm._v("Administration")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/user-management" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "user" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.userManagement")
                                )
                              }
                            },
                            [_vm._v("User management")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/jhi-tracker" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "eye" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.tracker")
                                )
                              }
                            },
                            [_vm._v("User tracker")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/jhi-metrics" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "tachometer-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.metrics")
                                )
                              }
                            },
                            [_vm._v("Metrics")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/jhi-health" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "heart" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.health")
                                )
                              }
                            },
                            [_vm._v("Health")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/jhi-configuration" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "list" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.configuration")
                                )
                              }
                            },
                            [_vm._v("Configuration")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/audits" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "bell" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.audits")
                                )
                              }
                            },
                            [_vm._v("Audits")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/admin/logs" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "tasks" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.logs")
                                )
                              }
                            },
                            [_vm._v("Logs")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.swaggerEnabled
                        ? _c(
                            "b-dropdown-item",
                            { attrs: { to: "/admin/docs" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "book" }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.apidocs")
                                    )
                                  }
                                },
                                [_vm._v("API")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.languages && Object.keys(_vm.languages).length > 1
                ? _c(
                    "b-nav-item-dropdown",
                    { attrs: { id: "languagesnavBarDropdown", right: "" } },
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "flag" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.language")
                                )
                              }
                            },
                            [_vm._v("Language")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.languages, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: "lang-" + key,
                            class: { active: _vm.isActiveLanguage(key) },
                            on: {
                              click: function($event) {
                                return _vm.changeLanguage(key)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(value.name) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/account") },
                  attrs: {
                    right: "",
                    href: "javascript:void(0);",
                    id: "account-menu",
                    "active-class": "active"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "navbar-dropdown-menu",
                      attrs: { slot: "button-content" },
                      slot: "button-content"
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("global.menu.account.main")
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Account\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/settings",
                            tag: "b-dropdown-item"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.settings")
                                )
                              }
                            },
                            [_vm._v("Settings")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/password",
                            tag: "b-dropdown-item"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "lock" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.password")
                                )
                              }
                            },
                            [_vm._v("Password")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "logout" },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-out-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.logout")
                                )
                              }
                            },
                            [_vm._v("Sign out")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "login" },
                          on: {
                            click: function($event) {
                              return _vm.openLogin()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-in-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.login")
                                )
                              }
                            },
                            [_vm._v("Sign in")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/register",
                            tag: "b-dropdown-item",
                            id: "register"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "user-plus" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.register")
                                )
                              }
                            },
                            [_vm._v("Register")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }